import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const primaryMobileNavItems = [
  { to: "/", label: "Agenda", testId: "mobile-nav-agenda-link" },
  { to: "/customers", label: "Clienti", testId: "mobile-nav-customers-link" },
  { to: "/services", label: "Servizi", testId: "mobile-nav-services-link" },
];

export const ownerMoreNavItems = [
  { to: "/staff", label: "Staff", testId: "mobile-nav-staff-link" },
  { to: "/business-profile", label: "Profilo attività", testId: "mobile-nav-business-profile-link" },
  { to: "/business-hours", label: "Orari", testId: "mobile-nav-business-hours-link" },
  { to: "/activity", label: "Registro attività", testId: "mobile-nav-activity-link" },
  { to: "/trash", label: "Cestino", testId: "mobile-nav-trash-link" },
  { to: "/recovery", label: "Recupero", testId: "mobile-nav-recovery-link" },
  { to: "/owner-alerts", label: "Avvisi", testId: "mobile-nav-owner-alerts-link" },
];

const mobileLinkClassName = ({ isActive }) =>
  `min-h-12 px-2 py-2 flex items-center justify-center text-center text-xs font-medium ${
    isActive ? "text-slate-900 bg-slate-100" : "text-slate-500"
  }`;

export function BottomNav() {
  const { isOwner } = useAuth();
  const location = useLocation();
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  const isMoreRouteActive = ownerMoreNavItems.some((item) => item.to === location.pathname);

  useEffect(() => {
    setIsMoreOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isMoreOpen) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setIsMoreOpen(false);
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [isMoreOpen]);

  return (
    <>
      {isOwner && isMoreOpen && (
        <>
          <button
            type="button"
            aria-label="Chiudi menu mobile"
            className="md:hidden fixed inset-0 z-30 bg-slate-950/20"
            onClick={() => setIsMoreOpen(false)}
            data-testid="mobile-more-backdrop"
          />
          <section
            id="mobile-more-menu"
            className="mobile-more-menu-offset md:hidden fixed inset-x-3 z-50 max-h-[70vh] overflow-y-auto rounded-lg border border-slate-200 bg-white p-3 shadow-xl"
            aria-label="Altre pagine owner"
            data-testid="mobile-more-menu"
          >
            <div className="mb-2 flex items-center justify-between gap-3 px-2">
              <p className="text-sm font-semibold text-slate-900">Altre pagine</p>
              <button
                type="button"
                className="rounded-sm px-2 py-1 text-sm text-slate-500"
                onClick={() => setIsMoreOpen(false)}
                data-testid="mobile-more-close"
              >
                Chiudi
              </button>
            </div>
            <div className="grid grid-cols-2 gap-2">
              {ownerMoreNavItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={() => setIsMoreOpen(false)}
                  data-testid={item.testId}
                  className={({ isActive }) =>
                    `rounded-sm border px-3 py-3 text-sm font-medium ${
                      isActive
                        ? "border-slate-900 bg-slate-900 text-white"
                        : "border-slate-200 bg-white text-slate-700"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </section>
        </>
      )}

      <nav
        className="mobile-safe-bottom md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-slate-200 bg-white/95 backdrop-blur"
        aria-label="Navigazione mobile"
        data-testid="mobile-bottom-nav"
      >
        <ul className={`grid ${isOwner ? "grid-cols-4" : "grid-cols-3"}`}>
          {primaryMobileNavItems.map((item) => (
            <li key={item.to}>
              <NavLink to={item.to} data-testid={item.testId} className={mobileLinkClassName}>
                {item.label}
              </NavLink>
            </li>
          ))}
          {isOwner && (
            <li>
              <button
                type="button"
                aria-expanded={isMoreOpen}
                aria-controls="mobile-more-menu"
                onClick={() => setIsMoreOpen((current) => !current)}
                className={`min-h-12 w-full px-2 py-2 text-xs font-medium ${
                  isMoreOpen || isMoreRouteActive ? "bg-slate-100 text-slate-900" : "text-slate-500"
                }`}
                data-testid="mobile-nav-more-button"
              >
                Altro
              </button>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
}
